import React, { PureComponent } from 'react'
import MediaThumbComponent from '../components/mediaThumbComponent'
import colors from 'aria-viewer/tour/constants/style/colors'
import Icon from 'aria-viewer/tour/components/icon'

class MediaThumbContainer extends PureComponent {
    constructor(props) {
        super(props)

        this.handleOnClick = this.handleOnClick.bind(this)
    }

    handleOnClick(e) {
        const { onClick, media, index } = this.props
        onClick && onClick(e, media, index)
    }

    getOverlay() {
        if (this.props.overlay) {
            return (
                <div
                    onClick={this.handleOnClick}
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7))',
                        zIndex: 3,
                    }}
                >
                    <div
                        style={{
                            color: colors.white,
                            fontSize: '1.15em',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            whiteSpace: 'nowrap',
                            fontWeight: 600,
                        }}
                    >
                        Media Galleries
                        <div
                            style={{
                                width: 24,
                                height: 24,
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                marginLeft: 17,
                            }}
                        >
                            <Icon icon="more_media" />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const { width, height, size, round, gradient, style, showOverlay, thumbStyle, media } = this.props

        return (
            <div style={style}>
                <MediaThumbComponent
                    width={width}
                    height={height}
                    size={size}
                    round={round}
                    gradient={gradient}
                    media={media}
                    onClick={this.handleOnClick}
                    showOverlay={showOverlay}
                    thumbStyle={thumbStyle}
                />

                {this.getOverlay()}
            </div>
        )
    }
}

export default MediaThumbContainer
